import React from 'react'
import './PropertyRentCompT2.scss'
import PropTypes from 'prop-types'
import {
  PropertyImage,
  UnitMix,
  PropertyInfo,
  AmenitiesT2,
  DonutChartT2,
  Notes
} from '@components/custom'
import { ReactComponent as SummaryLogo } from '@src/assets/summary_right_logo.svg'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import {
  RENT_COMPARABLES,
  RENT_COMPS_PAGE_TITLE
} from '@engine/dependencies/constants'

export class PropertyRentCompT2 extends React.Component {
  editPropertyData = t => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, ...t })
  }

  editPropertyNotes = n => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, isNotesModified: true, notes: n })
  }

  editPropertySourceNotes = n => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, sourceNote: n })
  }

  render() {
    const {
      propertyType,
      templateName,
      templateDataLimits: {
        unitMixCount,
        amenitiesCount,
        notesCount,
        sourceNotesCount
      },
      themeColors,
      donutChartThemeColors,
      propertyNameList
    } = this.props
    const {
      propertyData,
      comparableData,
      chartData,
      signedUrl,
      hideUnitMixTotal,
      unitMixDisclaimerData
    } = this.props.propertyInfoData
    const {
      hasBranding,
      hasAmenities,
      hasNotes,
      hasSourceNotes,
      hasPageTitle,
      hasDonut
    } = this.props.toggleSettings ? this.props.toggleSettings : {}
    // const comparableDataT2 = [...comparableData]

    const AmenitiesT2Data = [...propertyData.amenities]
    const { showDisclaimer, disclaimerText } = propertyData

    // if (comparableDataT2.length > unitMixCount) {
    //   const comparableDataTotal = comparableDataT2.pop()
    //   comparableDataT2.splice(unitMixCount)
    //   comparableDataT2.push(comparableDataTotal)
    // }

    return (
      <div
        data-testid={`property-rent-comps-T2-${propertyType}`}
        className={(hasPageTitle || hasBranding) ? 'property-rent-comps-view-T2' : 'no-margin-property-rent-comps-view-T2'}
        id={`#property_${propertyType}`}
      >
        {(hasPageTitle || hasBranding) && (
          <>
            {propertyType.toString().includes('S') ? (
              <div>
                <div className="summary-header">
                  <span>
                    {hasPageTitle && (
                      <>
                        SUBJECT PROPERTY
                        <p
                          style={{ color: themeColors.globalSubColor }}
                        >{` - ${RENT_COMPS_PAGE_TITLE}`}</p>
                      </>
                    )}
                  </span>
                  {hasBranding && (
                    <SummaryLogo data-testid="logo-long" className="summary_logo" />
                  )}
                </div>
                <div className="subject-property" />
              </div>
            ) : (
              <div className="property-rent-comps-heading summary-header">
                <span style={{ color: themeColors.globalSubColor }}>
                  {hasPageTitle ? RENT_COMPS_PAGE_TITLE : ''}
                </span>
                {hasBranding && (
                  <SummaryLogo data-testid="logo-long" className="summary_logo" />
                )}
              </div>
            )}
          </>
        )}

        <div className="property-container">
          <div className="property-container-left">
            <PropertyImage
              propertyType={propertyType}
              imageUrl={signedUrl || ''}
              templateName={templateName}
            />
            <PropertyInfo
              propertyInfo={propertyData}
              propertyType={propertyType}
              templateName={templateName}
              propertyNameList={propertyNameList}
            />
            <div className="source_notes">
              {templateName.includes(RENT_COMPARABLES) && hasSourceNotes && (
                <Notes
                  notesContent={propertyData.sourceNote}
                  notesLimit={sourceNotesCount}
                  updateNotes={this.editPropertySourceNotes}
                  propertyLabel={'sourcenotes'}
                />
              )}
            </div>
            <div className="empty_notes">
              {templateName.includes(RENT_COMPARABLES) && hasNotes && (
                <Notes
                  notesContent={propertyData.notes}
                  notesLimit={notesCount}
                  updateNotes={this.editPropertyNotes}
                  propertyLabel={'notes'}
                />
              )}
            </div>
          </div>
          <div className="property-container-center">
            <UnitMix
              hideUnitMixTotal={hideUnitMixTotal}
              comparableData={comparableData}
              unitMixCount={unitMixCount}
              propertyType={propertyType}
              unitMixDisclaimerData={unitMixDisclaimerData}
            />
          </div>
          <div className="property-container-right">
            {hasDonut && (
              <DonutChartT2
                chartData={chartData}
                donutChartThemeColors={donutChartThemeColors}
                propertyType={propertyType}
                themeColors={themeColors}
              />
            )}
            {hasAmenities && (
              <AmenitiesT2
                amenities={AmenitiesT2Data}
                amenitiesCount={amenitiesCount}
                editPropertyData={this.editPropertyData}
                propertyType={propertyType}
                themeColors={themeColors}
                disclaimerText={disclaimerText}
                showDisclaimer={showDisclaimer}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

PropertyRentCompT2.propTypes = {
  donutChartThemeColors: PropTypes.object,
  amenitiesCount: PropTypes.number,
  editFeature: PropTypes.func,
  templateName: PropTypes.string,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasSourceNotes: PropTypes.bool,
    hasAmenities: PropTypes.bool,
    hasPageTitle: PropTypes.bool,
    hasDonut: PropTypes.bool
  }),
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  propertyInfoData: PropTypes.shape({
    propertyData: PropTypes.object,
    comparableData: PropTypes.arrayOf(PropTypes.object),
    chartData: PropTypes.shape({
      '1 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 2 Bath': PropTypes.number,
      '3 Bedroom / 3 Bath': PropTypes.number
    }),
    signedUrl: PropTypes.string,
    hideUnitMixTotal: PropTypes.bool,
    unitMixDisclaimerData: PropTypes.object
  }),
  templateDataLimits: PropTypes.shape({
    unitMixCount: PropTypes.number,
    amenitiesCount: PropTypes.number,
    notesCount: PropTypes.number
  }),
  themeColors: PropTypes.object,
  propertyNameList: PropTypes.array
}

const mapStateToProps = state => ({
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state),
  themeColors: Comps.selectors.comps.themeColors(state)
})

export default connect(mapStateToProps)(PropertyRentCompT2)
